import { ArsTableState } from "../interface";

/**
 * Marks the current table state as no longer dirty after changes have been sent.
 *
 * @param state - Current ARS table state
 * @returns Updated ARS table state
 */
export const arst_changeSent = <T>(state: ArsTableState<T>): ArsTableState<T> => ({
  ...state,
  changed: false,
});
